import { UseControllerProps } from 'react-hook-form';

type Rules = UseControllerProps['rules'];

export const googleMapsUrlRules: Rules = {
    validate: (val: string) => {
        const isValid = validateGoogleMapsUrl(val);
        return isValid ? true : 'Invalid Google Maps link';
    },
};

const validateGoogleMapsUrl = (url: string | null): boolean => {
    if (!url) return true;
    return validGoogleMapRegex.test(url);
};

export const validGoogleMapRegex =
    /^(https?:\/\/)?(www\.)?(?:(?:google\.com)\/maps|(?:maps\.google\.com)|(?:goo\.gl)\/maps|(?:maps\.app\.goo\.gl))(?:\/(?:place\/|@|search\/|dir\/|embed\/|print\/)?([^?&]+)?(\?[^&]+)?(&[^&]+)*)?$/i;
